<template>
  <div class="callIn">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        应收账款列表
        <div class="rutun" @click="geting()">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;" class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">商城账号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="bind_mobile" clearable size="small" placeholder="商城账号"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">订单编号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="orderCode" clearable size="small" placeholder="备注名称"></el-input>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <!-- <div class="center_list_head_rig" @click="dialogFormVisible1 = true">添加客户</div> -->
        </div>
        <div class="center_list_center"></div>
      </div>

      <el-table v-show="group!=7" :data="tableData" border style="width: 100%">
        <el-table-column prop="bind_mobile" label="商城账号" width="120"></el-table-column>
        <el-table-column label="订单编号" width="180">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/d_viewOrde/'+scope.row.id+'/1'">
              <el-link type="primary">{{scope.row.orderCode}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="pay_money" label="应收金额(元)" width="110"></el-table-column>
        <el-table-column prop="pay_days_end" label="货期时间" width="100"></el-table-column>
        <el-table-column prop="remark_name" label="备注名称" width="100"></el-table-column>
        <el-table-column prop="address" label="收货信息"></el-table-column>
        <el-table-column prop="status" width="80" label="状态"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div>
              <el-link type="primary" @click="showInputMoney = true,inputMoneyOrderCode = scope.row.orderCode">确认回款</el-link>
            </div>
            <div style="padding-right:10px">
              <el-link
                style="margin-left:10px"
                @click="showCall = true,callForm.orderCode = scope.row.orderCode"
                type="primary"
              >催款操作</el-link>
            </div>
            <div style="padding-right:10px">
              <el-link style="margin-left:10px" type="primary" @click="showCallList = true,getCallList(1,scope.row.orderCode)">催款记录</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-show="group == 7" :data="tableData" border style="width: 100%">
        <el-table-column prop="bind_mobile" label="商城账号" width="120"></el-table-column>
        <el-table-column label="订单编号" width="180">
          <template slot-scope="scope">
            <router-link target="_blank" :to="'/admin/d_viewOrde/'+scope.row.id+'/1'">
              <el-link type="primary">{{scope.row.orderCode}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="pay_money" label="应收金额(元)" width="110"></el-table-column>
        <el-table-column prop="pay_days_end" label="货期时间" width="100"></el-table-column>
        <el-table-column prop="remark_name" label="备注名称" width="100"></el-table-column>
        <el-table-column prop="real_name" label="负责(销售员)" width="110"></el-table-column>
        <el-table-column prop="address" label="收货信息"></el-table-column>
        <el-table-column prop="status" width="80" label="状态"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div>
              <el-link type="primary" @click="showInputMoney = true,inputMoneyOrderCode = scope.row.orderCode">确认回款</el-link>
            </div>
            <div style="padding-right:10px">
              <el-link
                style="margin-left:10px"
                @click="showCall = true,callForm.orderCode = scope.row.orderCode"
                type="primary"
              >催款操作</el-link>
            </div>
            <div style="padding-right:10px">
              <el-link
                style="margin-left:10px"
                @click="getCallList(1,scope.row.orderCode),callListOrderCode = scope.row.orderCode"
                type="primary"
              >催款记录</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager1" v-show="total > 15">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
        ></el-pagination>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加我的催款记录 -->
    <el-dialog title="添加催款记录" :visible.sync="showCall" width="33%">
      <el-form :label-position="labelPosition" label-width="80px" :model="callForm">
        <el-form-item label="订单编号:">
          <el-input
            style="width:356px"
            v-model="callForm.orderCode"
            :disabled="true"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="催款人员:">
          <el-input style="width:356px" v-model="callForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="催款方式:">
          <el-select v-model="callForm.type" placeholder="请选择">
            <el-option
              v-for="item in callType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拜访时间:">
          <el-input
            :placeholder=today
            style="width:356px"
            v-model="callForm.call_date"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input
            type="textarea"
            :rows="2"
            style="width:356px"
            v-model="callForm.remark"
            autocomplete="off"
            maxlength="250"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCall = false">取 消</el-button>
        <el-button type="primary" @click="addCallList()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看存款记录 -->
    <el-dialog title="催款记录" :visible.sync="showCallList">
      <el-table border :data="callData">
        <el-table-column property="orderCode" label="订单编号" width="200"></el-table-column>
        <el-table-column property="name" label="催款人" width="100"></el-table-column>
        <el-table-column property="type" label="催款方式" width="80"></el-table-column>
        <el-table-column property="call_date" label="催款时间" width="110"></el-table-column>
        <el-table-column property="create_member" label="创建人" width="80"></el-table-column>
        <el-table-column show-overflow-tooltip property="remark" label="备注"></el-table-column>
      </el-table>
      <div v-show="total1 > 5" class="pager1">
        <el-pagination
          @current-change="setPage2"
          :page-size="5"
          background
          layout="prev, pager, next"
          :total="total1"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 回款确认 -->
    <el-dialog title="回款金额确认" :visible.sync="showInputMoney" width="33%">
      <el-form>
        <el-form-item label="回款金额:" label-width="100px">
          <el-input v-model="input_money" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showInputMoney = false">取 消</el-button>
        <el-button type="primary" @click="showInputMoney = false,confirmCallIn()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return { serve: this.$store.state.serve, serve: this.$store.state.serve,
      role:true,
      serve: this.$store.state.serve,
      token: this.$cookies.get('token'),
      username: this.$cookies.get('username'),
      page: null,
      total: 0,
      tableData: [],
      bind_mobile: '',
      orderCode: '',
      group: '',
      showCall: false,
      callForm: {},
      labelPosition: 'left',
      callType: [
        {
          value: '电话催款',
          label: '电话催款'
        },
        {
          value: '上门催款',
          label: '上门催款'
        },
        {
          value: '短信催款',
          label: '短信催款'
        },
        {
          value: '其他方式',
          label: '其他方式'
        }
      ],
      showCallList: false,
      callData: [],
      callListOrderCode: '',
      total1: 0,
      input_money:'',
      showInputMoney:false,
      inputMoneyOrderCode:'',
      today:''
    }
  },
  created() {
    var day = new Date();
    day.setTime(day.getTime());
    var today = day.getFullYear()+"-" + (day.getMonth()+1) + "-" + day.getDate();
    this.today = today
    this.$store.state.topActiveId = 9
    this.$store.state.leftTitle = '应收账款'
    this.geting()
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection()
      } else {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleAllSelection()
      }
    }
  },
  methods: {
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    confirmCallIn() {
      this.$confirm('确定订单已经回款?确定', '回款确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var where = {
            username: this.username,
            token: this.token,
            orderCode: this.inputMoneyOrderCode,
            input_money: this.input_money
          }
          this.axios
            .get(this.serve + '/admin/admin_pay', { params: where })
            .then(res => {
              var data = res.data
              if (data.status == 'success') {
                this.alert_success('操作成功!')
                this.geting();
              } else {
                this.alert_error('操作失败!')
              }
              
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
            offset: 200
          })
        })
    },
    setPage2(v) {
      this.getCallList(v, this.callListOrderCode)
    },
    getCallList(v, orderCode) {
      this.showCallList = true
      var where = {
        username: this.username,
        token: this.token,
        orderCode: orderCode,
        page: v
      }
      this.axios
        .get(this.serve + '/admin/getCallList', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.callData = data.data.results
            this.total1 = data.data.total
          } else {
            this.callData = []
            this.total1 = 0
          }
        })
    },
    addCallList() {
      var where = {
        username: this.username,
        token: this.token,
        callForm: this.callForm
      }
      this.axios
        .get(this.serve + '/admin/addCallList', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.alert_success('添加成功')
            this.callForm = {}
            this.showCall = false
          } else {
            this.alert_error(data.msg)
          }
        })
    },
    setPage(v) {
      //分页
      this.page = v
      this.geting(v)
      this.selectAll = false
    },
    geting(page) {
      //请求数据
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var that = this
      var where = {
        username: this.username,
        token: this.token,
        page: page ? page : this.page
      }
      where.bind_mobile = this.bind_mobile
      where.orderCode = this.orderCode
      this.axios
        .get(this.serve + '/admin/callIn', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.tableData = data.data.results
            this.total = data.data.total
            this.page = data.data.page
            this.group = data.data.group
          } else {
            if(data.msg == "无权访问"){
              this.role = false
            }
            this.tableData = []
            this.total = 0
          }
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss">
.callIn {
    .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top:19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>